import { styled } from '@mui/material/styles';
import { Box, Typography, Button, Tabs, Tab } from '@mui/material';

export const BackgroundContainer = styled(Box)({
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: '50px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
});

export const LoginContainer = styled(Box)(() => ({
    width: '100%',
    maxWidth: '500px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '16px',
    marginTop: '40px',
}));

export const PaperContainer = styled(Box)(() => ({
    padding: '32px',
    borderRadius: '16px',
    width: '100%',
    textAlign: 'center',
    backgroundColor: '#fff',
}));

export const LogoContainer = styled(Box)(() => ({
    textAlign: 'center',
    marginBottom: '50px',

    '& img': {
        display: 'block',
        margin: '0 auto',
        height: 200,
        maxWidth: '100%',
    },
}));

export const LoginHeader = styled(Typography)(() => ({
    fontWeight: 'bold',
    color: 'black',
    fontSize: '2rem',
    textAlign: 'center',
    marginBottom: '30px',
}));

export const ErrorText = styled(Typography)(() => ({
    color: 'red',
    textAlign: 'center',
    margin: '16px 0',
}));

export const FormContainer = styled(Box)(() => ({
    marginTop: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
}));

export const SubmitButton = styled(Button)(() => ({
    marginTop: '24px',
    marginBottom: '16px',
    backgroundColor: '#002F87',
}));

export const ForgotPasswordText = styled(Typography)(() => ({
    marginTop: '15px',
    textAlign: 'center',
}));

export const StyledTabs = styled(Tabs)({
    backgroundColor: '#f5f5f5',
    borderRadius: '8px',
    padding: '6px',
    minHeight: '40px',
    marginBottom: '16px',
    '& .MuiTabs-indicator': {
        display: 'none',
    },
});

export const StyledTab = styled(Tab)({
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: '6px',
    minHeight: '32px',
    flex: 1,
    margin: '0 2px',
    '&.Mui-selected': {
        backgroundColor: '#002F87',
        color: '#fff',
    },
    '&:not(.Mui-selected)': {
        color: '#888',
    },
    '&:hover': {
        backgroundColor: '#e0e0e0', 
    },
});
